
import React, { useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import KPICards from './dashboard/KPICards';
import AnalyticsChart from './dashboard/AnalyticsChart';
import StatusDonuts from './dashboard/StatusDonuts';
import Leaderboards from './dashboard/Leaderboards';
import QueueSnapshot from './dashboard/QueueSnapshot';
import ApprovedListings from './dashboard/ApprovedListings';

const AdminDashboard = () => {
  const { t } = useLanguage();
  const [period, setPeriod] = useState('30');
  const [chartType, setChartType] = useState('area');

  return (
    <div className="space-y-6">
      {/* Period Controls */}
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">
          {t('dashboard', 'لوحة التحكم', 'Dashboard')}
        </h2>
        <div className="flex items-center gap-2">
          <Select value={period} onValueChange={setPeriod}>
            <SelectTrigger className="w-[120px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="7">{t('7_days', '7 أيام', '7 Days')}</SelectItem>
              <SelectItem value="30">{t('30_days', '30 يوماً', '30 Days')}</SelectItem>
              <SelectItem value="90">{t('90_days', '90 يوماً', '90 Days')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* KPI Cards */}
      <KPICards period={period} />

      {/* Analytics and Status Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>{t('analytics_overview', 'نظرة عامة على التحليلات', 'Analytics Overview')}</CardTitle>
            <CardDescription>
              {t('trends_insights', 'اتجاهات ورؤى النشاط', 'Activity trends and insights')}
            </CardDescription>
            <div className="flex items-center gap-2 mt-4">
              <Select value={chartType} onValueChange={setChartType}>
                <SelectTrigger className="w-[120px]">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="area">{t('area', 'منطقة', 'Area')}</SelectItem>
                  <SelectItem value="line">{t('line', 'خط', 'Line')}</SelectItem>
                  <SelectItem value="bar">{t('bar', 'شريط', 'Bar')}</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </CardHeader>
          <CardContent>
            <AnalyticsChart period={period} type={chartType} />
          </CardContent>
        </Card>

        <StatusDonuts />
      </div>

      {/* Approved Listings Section */}
      <ApprovedListings />

      {/* Leaderboards - now takes full width since Activity Feed is removed */}
      <Leaderboards period={period} />

      {/* Queue Snapshot */}
      <QueueSnapshot />
    </div>
  );
};

export default AdminDashboard;
